export default "__VITE_ASSET__DoWEXPHM__"